// extracted by mini-css-extract-plugin
export default {"form-section":"SetPassword_form-section__kLuoN","input-box":"SetPassword_input-box__VLqPF","info-section":"SetPassword_info-section__A0e2S","icon":"SetPassword_icon__Tbu0P"};